const Period = {
  generate() {
    return {
      id: null,
      range: [undefined, undefined],
    };
  },
  rulesBlock() {
    return {
      type: 'object',
      required: true,
      message: 'Необходимо указать период',
    };
  }
};

export { Period };